<template>
  <div class="otn-step-two">
    <v-layout>
      <v-switch
        v-model="isAttachmentsEnabled"
        hide-details
        label="Fixations :"
        class="mb-4 title"
        @change="clearBreastplateFields"
      />
    </v-layout>

    <AttachmentsTable
      :config="otnConfig.steps[0].sections[0].config"
      :form="form"
      :dropdowns="dropdowns"
      :disabled="!isAttachmentsEnabled"
    />

    <v-layout
      justify-space-between
      wrap
      class="mt-4"
    >
      <v-layout>
        <v-switch
          v-model="isFinishingSectionEnabled"
          hide-details
          class="mb-4 title"
          label="Finition :"
        />
      
      </v-layout>
    </v-layout>

    
    <v-layout
      justify-space-between
      wrap
    >
      <v-flex sm6>
        <v-checkbox
          v-model="form.idc_anti_pressure_ulcers"
          :disabled="!isFinishingSectionEnabled"
          hide-details
          class="mb-2"
          label="Mousse Anti Escarres"
        />

        <v-select
          v-model="form.foam_under_otn"
          :disabled="!isFinishingSectionEnabled"
          :items="dropdowns.foam_under_otn"
          item-text="label"
          item-value="value"
          label="Mousse sous l'OTN :"
          filled
          clearable
          hide-details
          class="mb-4"
        />
        <v-text-field
          v-model="form.thickness"
          :disabled="!isFinishingSectionEnabled"
          v-validate="'numeric|max:4'"
          data-vv-name="(Finition) Epaisseur"
          :class="{ error: errors.has('(Finition) Epaisseur') }"
          label="Epaisseur"
          type="number"
          outlined
          hide-details
        />
        <v-checkbox
          v-model="form.idc_coating"
          :disabled="!isFinishingSectionEnabled"
          hide-details
          class="mb-2"
          label="Coating sous l'OTN"
        />
        <v-text-field
          v-model="form.reinforcement"
          :disabled="!isFinishingSectionEnabled"
          label="Renfort :"
          hide-details
          maxlength="20"
          outlined
        />
      </v-flex>

      <v-flex sm6>
        <v-select
          v-model="form.matter"
          :disabled="!isFinishingSectionEnabled"
          :items="dropdowns.matter"
          item-text="label"
          item-value="value"
          label="Matière :"
          filled
          clearable
          hide-details
          class="mb-3"
        />

        <h3 class="mb-4">
          Poignée de portage :
        </h3>
        <v-select
          v-model="form.type_handle"
          :disabled="!isFinishingSectionEnabled"
          :items="dropdowns.type_handle"
          item-text="label"
          item-value="value"
          label="Aucune :"
          filled
          hide-details
          class="mb-4"
        />
        <v-text-field
          v-model="form.quantity"
          :disabled="!isFinishingSectionEnabled"
          v-validate="'numeric|max:4'"
          data-vv-name="(Poignée de portage) Quantité"
          :class="{ error: errors.has('(Poignée de portage) Quantité') }"
          label="Quantité :"
          type="number"
          class="mb-4"
          outlined
          hide-details
        />
        <v-text-field
          v-model="form.location"
          :disabled="!isFinishingSectionEnabled"
          label="Emplacement"
          maxlength="20"
          hide-details
          outlined
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { OTN_FORM_CONFIG } from "@/config/forms/otn-config";
import AttachmentsTable from "@/components/forms/advanced/AttachmentsTable.vue";

export default {
  name: "OtnStepTwo",
  components: {
    AttachmentsTable
  },
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      isAttachmentsEnabled: false,
      isFinishingSectionEnabled: false,
      otnConfig: OTN_FORM_CONFIG
    }
  },

  computed: {
    ...mapGetters({
      dropdowns: "dropdowns/getOtnOptions"
    })
  },
  created() {
    this.$validator = this.parentValidator;
  }
};
</script>

<style></style>
